import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import theme from 'styles/theme';
import { DownArrowIcon } from 'components/layout/NavbarNew/menuIcons';

const shouldForwardProp = (prop: string) =>
  !['selected', 'isSelected', 'hidden', 'open', 'height'].includes(prop);

const activeItemStyles = css`
  border-left: 3px solid ${theme.colors.blueClean};

  & svg.menu-icon {
    color: ${theme.colors.blueClean};
    margin-left: 19px;
  }

  & span {
    color: ${theme.colors.blueClean};
    font-weight: 700;
  }
`;

type Selected = {
  selected?: boolean;
  isSelected?: boolean;
};

export const MenuItem = styled('div', { shouldForwardProp })<{ hidden?: boolean }>`
  min-height: 36px;
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    text-decoration: none;
  }

  ${({ hidden }) =>
    hidden &&
    css`
      min-height: 0;
      display: none;
    `}
`;

export const MenuItemLink = styled('div', { shouldForwardProp })<Selected>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px;

  & svg.menu-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #fff;
    margin-left: 22px;
    transition: color 0.2s ease, margin-left 0.2s ease;
  }

  &:hover {
    ${activeItemStyles}
  }

  ${({ selected }) => selected && activeItemStyles}
`;

export const LinkCustom = styled(Link)`
  display: flex;
`;

export const SubMenuAction = styled.button`
  display: flex;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const MenuItemText = styled('span', { shouldForwardProp })<Selected>`
  font-size: 15px;
  color: #fff;
  margin-left: 16px;
  font-family: 'Mangueira', sans-serif;
  flex: 1;

  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: 700;
      color: #fff;
    `}
`;

export const AccessibilityReadOnly = styled.span`
  display: none;
  visibility: hidden;
`;

export const ContainerMenuItem = styled.div`
  flex: 1;
`;

type OpenHeight = {
  open?: boolean;
  height?: number;
};

export const SubMenuContainer = styled('div', { shouldForwardProp })<OpenHeight>`
  display: flex;
  flex-direction: column;
  transition: max-height 0.5s ease;
  overflow: hidden;
  max-height: ${({ open, height }) => (open ? `${height}px` : 0)};

  a:first-child,
  button:first-child {
    margin-top: 15px;
  }

  a:last-child,
  button:last-child {
    margin-bottom: 15px;
  }

  a,
  button {
    margin-left: 49px;
  }

  a:not(:last-child),
  button:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const Arrow = styled(DownArrowIcon, { shouldForwardProp })<OpenHeight>`
  margin-left: auto;
  margin-right: 15px;
  width: 15px;
  height: 9px;
  flex-shrink: 0;
  color: #fff;
  transition: transform 0.5s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
